// src/mocks/handlers.js
import advertisement from './rest/advertisement'
import card from './rest/card'
import chain from './rest/chain'
import contact from './rest/contact'
import content from './rest/content'
import feature from './rest/feature'
import flyer from './rest/flyer'
import history from './rest/history'
import impressions from './rest/impressions'
import login from './rest/login'
import media from './rest/media'
import message from './rest/message'
import myshop from './rest/myshop'
import mystery from './rest/mystery'
import ogp from './rest/ogp'
import pricing from './rest/pricing'
import product from './rest/product'
import service from './rest/service'
import stampsheet from './rest/stampsheet'
import user from './rest/user'
export const handlers = [
  ...advertisement,
  ...card,
  ...chain,
  ...contact,
  ...content,
  ...feature,
  ...flyer,
  ...history,
  ...impressions,
  ...login,
  ...media,
  ...message,
  ...myshop,
  ...mystery,
  ...ogp,
  ...pricing,
  ...product,
  ...service,
  ...stampsheet,
  ...user,
]
